import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ImportExportCard = ({ 
  onImport, 
  onExport, 
  onBackup,
  className = '' 
}) => {
  const [isImporting, setIsImporting] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [isBackingUp, setIsBackingUp] = useState(false);

  const handleFileImport = async (event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;

    setIsImporting(true);
    try {
      await onImport(file);
    } catch (error) {
      console.error('Import failed:', error);
    } finally {
      setIsImporting(false);
      event.target.value = '';
    }
  };

  const handleExport = async () => {
    setIsExporting(true);
    try {
      await onExport();
    } catch (error) {
      console.error('Export failed:', error);
    } finally {
      setIsExporting(false);
    }
  };

  const handleBackup = async () => {
    setIsBackingUp(true);
    try {
      await onBackup();
    } catch (error) {
      console.error('Backup failed:', error);
    } finally {
      setIsBackingUp(false);
    }
  };

  return (
    <div className={`space-y-4 ${className}`}>
      {/* Import Section */}
      <div className="bg-muted rounded-lg p-4">
        <div className="flex items-center space-x-2 mb-3">
          <Icon name="Upload" size={18} className="text-primary" />
          <h4 className="font-medium text-text-primary">Import Contacts</h4>
        </div>
        <p className="text-sm text-text-secondary mb-4">
          Upload CSV or Excel files to import your contacts. Supported formats: .csv, .xlsx, .xls
        </p>
        <div className="flex items-center space-x-3">
          <Input
            type="file"
            accept=".csv,.xlsx,.xls"
            onChange={handleFileImport}
            disabled={isImporting}
            className="flex-1"
          />
          <Button
            variant="outline"
            size="sm"
            loading={isImporting}
            iconName="HelpCircle"
            iconPosition="left"
          >
            Format Guide
          </Button>
        </div>
      </div>

      {/* Export Section */}
      <div className="bg-muted rounded-lg p-4">
        <div className="flex items-center space-x-2 mb-3">
          <Icon name="Download" size={18} className="text-primary" />
          <h4 className="font-medium text-text-primary">Export Data</h4>
        </div>
        <p className="text-sm text-text-secondary mb-4">
          Download all your contacts and message history as CSV files for backup or migration.
        </p>
        <Button
          variant="default"
          size="sm"
          onClick={handleExport}
          loading={isExporting}
          iconName="Download"
          iconPosition="left"
        >
          Export All Data
        </Button>
      </div>

      {/* Backup Section */}
      <div className="bg-muted rounded-lg p-4">
        <div className="flex items-center space-x-2 mb-3">
          <Icon name="Shield" size={18} className="text-primary" />
          <h4 className="font-medium text-text-primary">Create Backup</h4>
        </div>
        <p className="text-sm text-text-secondary mb-4">
          Create a complete backup of your data including contacts, templates, and settings.
        </p>
        <div className="flex items-center space-x-3">
          <Button
            variant="default"
            size="sm"
            onClick={handleBackup}
            loading={isBackingUp}
            iconName="Shield"
            iconPosition="left"
          >
            Create Backup
          </Button>
          <span className="text-xs text-text-secondary">
            Last backup: December 10, 2024
          </span>
        </div>
      </div>
    </div>
  );
};

export default ImportExportCard;